import { plainToClass } from "class-transformer";
import { FormatDate, GetDateFromString } from "../../scripts/date-functions";
import { FileTimestamp } from "./date-updated-section.entities";

export class DateUpdatedSection {
    constructor(dataJson: any, showCTMS: boolean = true, showMedidata: boolean = true, showSalesforce: boolean = true, showFinance: boolean = false, showCareEvo: boolean = false, showBio: boolean = false) {

        $(() => {

            let fileTimestamps: FileTimestamp[] = plainToClass(FileTimestamp, <FileTimestamp[]>dataJson);

            fileTimestamps.forEach((file: FileTimestamp) => {
                let date: Date = GetDateFromString(file.FileDate, "slash-month-day-year");
                if (file.Name == "CTMS" && showCTMS) { $('#last-update-date-ctms').html(FormatDate(date)); }
                else if (file.Name == "Medidata" && showMedidata) { $('#last-update-date-medidata').html(FormatDate(date)); }
                else if (file.Name == "Salesforce" && showSalesforce) { $('#last-update-date-salesforce').html(FormatDate(date)); }
                else if (file.Name == "CareEvo" && showCareEvo) { $('#last-update-date-careevo').html(FormatDate(date)); }
                else if (file.Name == "Bio" && showBio) { $('#last-update-date-bio').html(FormatDate(date)); }
            });

            if (!showCTMS) $('#updated-section-ctms').hide();
            if (!showMedidata) $('#updated-section-medidata').hide();
            if (!showSalesforce) $('#updated-section-salesforce').hide();
            if (!showFinance) $('#updated-section-salesforce').hide();
            if (!showCareEvo) $('#updated-section-careevo').hide();
            if (!showBio) $('#updated-section-bio').hide();
            $('#date-updated-section').removeClass('invisible');

        });

    }
}